module.exports = __webpack_public_path__ + "static/img/icon-CN.36920b44.svg";